import HighlightText from '@common/components/highlighText';
import React, { useState } from 'react';
import moment from 'moment';

export const RacingFutureSpecialCompItems = ({
  comp, region, onSelectGame, alwaysOpen, search, routePrefix
}) => {
  const [openedComp, SetOpenedComp] = useState(false);
  const compDropDownClick = () => {
    SetOpenedComp(!openedComp);
  };

  return (
    <div
      key={comp.id}
      className={`fs-competition ${openedComp ? 'compClosed' : ''}`}
      onClick={(e) => {
        !alwaysOpen && compDropDownClick();
        e.stopPropagation();
      }}
    >
      <div className="competition-name">
        <HighlightText
          text={comp.name}
          highlightPart={search}
        />
        {!alwaysOpen && (
          <div className="arrow-section">
            {openedComp ? <i className="global-icon icon-thin-arrow-down" /> : <i className="global-icon icon-thin-arrow-up" />}
          </div>
        )}
      </div>
      <div className="fs-game-container">
        {comp.games.map((game) => (
          <div
            className="fs-game-item"
            key={game.id}
            onClick={(e) => onSelectGame(
              e,
              routePrefix,
              region.alias,
              region.id,
              comp.id,
              game.id,
              'special_futures',
            )}
          >

            <div className="game">
              {game.team1_name}
              {' '}
              {moment.unix(game?.start_ts).format('DD MMM HH:mm')}
            </div>
          </div>
        ))}
      </div>
    </div >
  );
};
